// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file realtime_event/realtime_event.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenEnum, GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { enumDesc, fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

import type { CalendarAction, CalendarEvent } from '../calendar/event_model_pb';
import { file_calendar_event_model } from '../calendar/event_model_pb';
import type { ChatState, ChatUpdate } from '../chat/chat_update_model_pb';
import { file_chat_chat_update_model } from '../chat/chat_update_model_pb';
import type { Device_Status } from '../device/device_model_pb';
import { file_device_device_model } from '../device/device_model_pb';
import type { Message as Message$1 } from '../message/message_model_pb';
import { file_message_message_model } from '../message/message_model_pb';
import type { UserStatus } from '../user/user_model_pb';
import { file_user_user_model } from '../user/user_model_pb';

/**
 * Describes the file realtime_event/realtime_event.proto.
 */
export const file_realtime_event_realtime_event: GenFile =
  /*@__PURE__*/
  fileDesc(
    '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',
    [
      file_user_user_model,
      file_chat_chat_update_model,
      file_message_message_model,
      file_calendar_event_model,
      file_device_device_model,
    ]
  );

/**
 * @generated from message com.gem.bff.contract.CallsActiveRealtimeEvent
 */
export type CallsActiveRealtimeEvent = Message<'com.gem.bff.contract.CallsActiveRealtimeEvent'> & {
  /**
   * @generated from field: repeated com.gem.bff.contract.CallUpdate items = 1;
   */
  items: CallUpdate[];
};

/**
 * Describes the message com.gem.bff.contract.CallsActiveRealtimeEvent.
 * Use `create(CallsActiveRealtimeEventSchema)` to create a new message.
 */
export const CallsActiveRealtimeEventSchema: GenMessage<CallsActiveRealtimeEvent> =
  /*@__PURE__*/
  messageDesc(file_realtime_event_realtime_event, 0);

/**
 * @generated from message com.gem.bff.contract.CallSingleUpdateRealtimeEvent
 */
export type CallSingleUpdateRealtimeEvent =
  Message<'com.gem.bff.contract.CallSingleUpdateRealtimeEvent'> & {
    /**
     * @generated from field: com.gem.bff.contract.CallUpdate callUpdate = 1;
     */
    callUpdate?: CallUpdate;
  };

/**
 * Describes the message com.gem.bff.contract.CallSingleUpdateRealtimeEvent.
 * Use `create(CallSingleUpdateRealtimeEventSchema)` to create a new message.
 */
export const CallSingleUpdateRealtimeEventSchema: GenMessage<CallSingleUpdateRealtimeEvent> =
  /*@__PURE__*/
  messageDesc(file_realtime_event_realtime_event, 1);

/**
 * @generated from message com.gem.bff.contract.CallIncomingRealtimeEvent
 */
export type CallIncomingRealtimeEvent =
  Message<'com.gem.bff.contract.CallIncomingRealtimeEvent'> & {
    /**
     * @generated from field: int64 chatId = 1;
     */
    chatId: bigint;

    /**
     * @generated from field: string channelId = 2;
     */
    channelId: string;

    /**
     * @generated from field: int64 callerId = 3;
     */
    callerId: bigint;

    /**
     * @generated from field: string callerName = 4;
     */
    callerName: string;

    /**
     * @generated from field: optional string callerAvatarUrl = 5;
     */
    callerAvatarUrl?: string;

    /**
     * @generated from field: int64 callVisibleDuration = 7;
     */
    callVisibleDuration: bigint;
  };

/**
 * Describes the message com.gem.bff.contract.CallIncomingRealtimeEvent.
 * Use `create(CallIncomingRealtimeEventSchema)` to create a new message.
 */
export const CallIncomingRealtimeEventSchema: GenMessage<CallIncomingRealtimeEvent> =
  /*@__PURE__*/
  messageDesc(file_realtime_event_realtime_event, 2);

/**
 * @generated from message com.gem.bff.contract.ChatsUpdateRealtimeEvent
 */
export type ChatsUpdateRealtimeEvent = Message<'com.gem.bff.contract.ChatsUpdateRealtimeEvent'> & {
  /**
   * @generated from field: repeated com.gem.bff.contract.ChatUpdate items = 1;
   */
  items: ChatUpdate[];
};

/**
 * Describes the message com.gem.bff.contract.ChatsUpdateRealtimeEvent.
 * Use `create(ChatsUpdateRealtimeEventSchema)` to create a new message.
 */
export const ChatsUpdateRealtimeEventSchema: GenMessage<ChatsUpdateRealtimeEvent> =
  /*@__PURE__*/
  messageDesc(file_realtime_event_realtime_event, 3);

/**
 * @generated from message com.gem.bff.contract.MessagesUpdateRealtimeEvent
 */
export type MessagesUpdateRealtimeEvent =
  Message<'com.gem.bff.contract.MessagesUpdateRealtimeEvent'> & {
    /**
     * @generated from field: repeated com.gem.bff.contract.MessageUpdate items = 1;
     */
    items: MessageUpdate[];
  };

/**
 * Describes the message com.gem.bff.contract.MessagesUpdateRealtimeEvent.
 * Use `create(MessagesUpdateRealtimeEventSchema)` to create a new message.
 */
export const MessagesUpdateRealtimeEventSchema: GenMessage<MessagesUpdateRealtimeEvent> =
  /*@__PURE__*/
  messageDesc(file_realtime_event_realtime_event, 4);

/**
 * @generated from message com.gem.bff.contract.MessageUpdate
 */
export type MessageUpdate = Message<'com.gem.bff.contract.MessageUpdate'> & {
  /**
   * @generated from field: com.gem.bff.contract.Message message = 1;
   */
  message?: Message$1;
};

/**
 * Describes the message com.gem.bff.contract.MessageUpdate.
 * Use `create(MessageUpdateSchema)` to create a new message.
 */
export const MessageUpdateSchema: GenMessage<MessageUpdate> =
  /*@__PURE__*/
  messageDesc(file_realtime_event_realtime_event, 5);

/**
 * @generated from message com.gem.bff.contract.MessageDeletedRealtimeEvent
 */
export type MessageDeletedRealtimeEvent =
  Message<'com.gem.bff.contract.MessageDeletedRealtimeEvent'> & {
    /**
     * @generated from field: int64 chatId = 1;
     */
    chatId: bigint;

    /**
     * @generated from field: int64 messageId = 2;
     */
    messageId: bigint;
  };

/**
 * Describes the message com.gem.bff.contract.MessageDeletedRealtimeEvent.
 * Use `create(MessageDeletedRealtimeEventSchema)` to create a new message.
 */
export const MessageDeletedRealtimeEventSchema: GenMessage<MessageDeletedRealtimeEvent> =
  /*@__PURE__*/
  messageDesc(file_realtime_event_realtime_event, 6);

/**
 * @generated from message com.gem.bff.contract.ChatSingleUpdateRealtimeEvent
 */
export type ChatSingleUpdateRealtimeEvent =
  Message<'com.gem.bff.contract.ChatSingleUpdateRealtimeEvent'> & {
    /**
     * @generated from field: com.gem.bff.contract.ChatUpdate chatUpdate = 1;
     */
    chatUpdate?: ChatUpdate;
  };

/**
 * Describes the message com.gem.bff.contract.ChatSingleUpdateRealtimeEvent.
 * Use `create(ChatSingleUpdateRealtimeEventSchema)` to create a new message.
 */
export const ChatSingleUpdateRealtimeEventSchema: GenMessage<ChatSingleUpdateRealtimeEvent> =
  /*@__PURE__*/
  messageDesc(file_realtime_event_realtime_event, 7);

/**
 * @generated from message com.gem.bff.contract.ChatStateChangedRealtimeEvent
 */
export type ChatStateChangedRealtimeEvent =
  Message<'com.gem.bff.contract.ChatStateChangedRealtimeEvent'> & {
    /**
     * @generated from field: repeated com.gem.bff.contract.ChatState items = 1;
     */
    items: ChatState[];
  };

/**
 * Describes the message com.gem.bff.contract.ChatStateChangedRealtimeEvent.
 * Use `create(ChatStateChangedRealtimeEventSchema)` to create a new message.
 */
export const ChatStateChangedRealtimeEventSchema: GenMessage<ChatStateChangedRealtimeEvent> =
  /*@__PURE__*/
  messageDesc(file_realtime_event_realtime_event, 8);

/**
 * @generated from message com.gem.bff.contract.UsersStatusUpdateRealtimeEvent
 */
export type UsersStatusUpdateRealtimeEvent =
  Message<'com.gem.bff.contract.UsersStatusUpdateRealtimeEvent'> & {
    /**
     * @generated from field: repeated com.gem.bff.contract.UserStatus items = 1;
     */
    items: UserStatus[];
  };

/**
 * Describes the message com.gem.bff.contract.UsersStatusUpdateRealtimeEvent.
 * Use `create(UsersStatusUpdateRealtimeEventSchema)` to create a new message.
 */
export const UsersStatusUpdateRealtimeEventSchema: GenMessage<UsersStatusUpdateRealtimeEvent> =
  /*@__PURE__*/
  messageDesc(file_realtime_event_realtime_event, 9);

/**
 * @generated from message com.gem.bff.contract.UserStatusSingleUpdateRealtimeEvent
 */
export type UserStatusSingleUpdateRealtimeEvent =
  Message<'com.gem.bff.contract.UserStatusSingleUpdateRealtimeEvent'> & {
    /**
     * @generated from field: com.gem.bff.contract.UserStatus userStatus = 1;
     */
    userStatus?: UserStatus;
  };

/**
 * Describes the message com.gem.bff.contract.UserStatusSingleUpdateRealtimeEvent.
 * Use `create(UserStatusSingleUpdateRealtimeEventSchema)` to create a new message.
 */
export const UserStatusSingleUpdateRealtimeEventSchema: GenMessage<UserStatusSingleUpdateRealtimeEvent> =
  /*@__PURE__*/
  messageDesc(file_realtime_event_realtime_event, 10);

/**
 * @generated from message com.gem.bff.contract.UserTypingMessageRealtimeEvent
 */
export type UserTypingMessageRealtimeEvent =
  Message<'com.gem.bff.contract.UserTypingMessageRealtimeEvent'> & {
    /**
     * @generated from field: int64 chatId = 1;
     */
    chatId: bigint;

    /**
     * @generated from field: int64 userId = 2;
     */
    userId: bigint;

    /**
     * @generated from field: string userName = 3;
     */
    userName: string;
  };

/**
 * Describes the message com.gem.bff.contract.UserTypingMessageRealtimeEvent.
 * Use `create(UserTypingMessageRealtimeEventSchema)` to create a new message.
 */
export const UserTypingMessageRealtimeEventSchema: GenMessage<UserTypingMessageRealtimeEvent> =
  /*@__PURE__*/
  messageDesc(file_realtime_event_realtime_event, 11);

/**
 * @generated from message com.gem.bff.contract.MessageSentRealtimeEvent
 */
export type MessageSentRealtimeEvent = Message<'com.gem.bff.contract.MessageSentRealtimeEvent'> & {
  /**
   * @generated from field: int64 chatId = 1;
   */
  chatId: bigint;

  /**
   * @generated from field: int64 userId = 2;
   */
  userId: bigint;
};

/**
 * Describes the message com.gem.bff.contract.MessageSentRealtimeEvent.
 * Use `create(MessageSentRealtimeEventSchema)` to create a new message.
 */
export const MessageSentRealtimeEventSchema: GenMessage<MessageSentRealtimeEvent> =
  /*@__PURE__*/
  messageDesc(file_realtime_event_realtime_event, 12);

/**
 * @generated from message com.gem.bff.contract.SessionInvalidatedRealtimeEvent
 */
export type SessionInvalidatedRealtimeEvent =
  Message<'com.gem.bff.contract.SessionInvalidatedRealtimeEvent'> & {};

/**
 * Describes the message com.gem.bff.contract.SessionInvalidatedRealtimeEvent.
 * Use `create(SessionInvalidatedRealtimeEventSchema)` to create a new message.
 */
export const SessionInvalidatedRealtimeEventSchema: GenMessage<SessionInvalidatedRealtimeEvent> =
  /*@__PURE__*/
  messageDesc(file_realtime_event_realtime_event, 13);

/**
 * @generated from message com.gem.bff.contract.DeviceStatusUpdateEvent
 */
export type DeviceStatusUpdateEvent = Message<'com.gem.bff.contract.DeviceStatusUpdateEvent'> & {
  /**
   * @generated from field: int64 userId = 1;
   */
  userId: bigint;

  /**
   * @generated from field: string deviceId = 2;
   */
  deviceId: string;

  /**
   * @generated from field: com.gem.bff.contract.Device.Status status = 3;
   */
  status: Device_Status;
};

/**
 * Describes the message com.gem.bff.contract.DeviceStatusUpdateEvent.
 * Use `create(DeviceStatusUpdateEventSchema)` to create a new message.
 */
export const DeviceStatusUpdateEventSchema: GenMessage<DeviceStatusUpdateEvent> =
  /*@__PURE__*/
  messageDesc(file_realtime_event_realtime_event, 14);

/**
 * @generated from message com.gem.bff.contract.PushNotificationRealtimeEvent
 */
export type PushNotificationRealtimeEvent =
  Message<'com.gem.bff.contract.PushNotificationRealtimeEvent'> & {
    /**
     * @generated from field: com.gem.bff.contract.PushNotificationRealtimeEvent.Type type = 1;
     */
    type: PushNotificationRealtimeEvent_Type;

    /**
     * @generated from field: int64 userId = 2;
     */
    userId: bigint;

    /**
     * @generated from field: optional int64 chatId = 3;
     */
    chatId?: bigint;

    /**
     * @generated from field: optional int64 messageId = 4;
     */
    messageId?: bigint;

    /**
     * @generated from field: optional string title = 5;
     */
    title?: string;

    /**
     * @generated from field: optional string subTitle = 6;
     */
    subTitle?: string;

    /**
     * @generated from field: optional string body = 7;
     */
    body?: string;

    /**
     * @generated from field: optional string icon = 8;
     */
    icon?: string;

    /**
     * @generated from field: optional int64 notificationTs = 9;
     */
    notificationTs?: bigint;
  };

/**
 * Describes the message com.gem.bff.contract.PushNotificationRealtimeEvent.
 * Use `create(PushNotificationRealtimeEventSchema)` to create a new message.
 */
export const PushNotificationRealtimeEventSchema: GenMessage<PushNotificationRealtimeEvent> =
  /*@__PURE__*/
  messageDesc(file_realtime_event_realtime_event, 15);

/**
 * @generated from enum com.gem.bff.contract.PushNotificationRealtimeEvent.Type
 */
export enum PushNotificationRealtimeEvent_Type {
  /**
   * @generated from enum value: CHAT_RENAMED = 0;
   */
  CHAT_RENAMED = 0,

  /**
   * @generated from enum value: CHAT_AVATAR_CHANGED = 1;
   */
  CHAT_AVATAR_CHANGED = 1,

  /**
   * @generated from enum value: CHAT_TYPE_CHANGED = 2;
   */
  CHAT_TYPE_CHANGED = 2,

  /**
   * @generated from enum value: CHAT_CATEGORY_CHANGED = 3;
   */
  CHAT_CATEGORY_CHANGED = 3,

  /**
   * @generated from enum value: CHAT_DELETED = 4;
   */
  CHAT_DELETED = 4,

  /**
   * @generated from enum value: CHAT_USER_JOIN = 6;
   */
  CHAT_USER_JOIN = 6,

  /**
   * @generated from enum value: CHAT_USER_LEAVE = 7;
   */
  CHAT_USER_LEAVE = 7,

  /**
   * @generated from enum value: CHAT_ADMIN_ADDED = 8;
   */
  CHAT_ADMIN_ADDED = 8,

  /**
   * @generated from enum value: CHAT_ADMINS_ADDED = 9;
   */
  CHAT_ADMINS_ADDED = 9,

  /**
   * @generated from enum value: CHAT_OWNER_CHANGED = 10;
   */
  CHAT_OWNER_CHANGED = 10,

  /**
   * @generated from enum value: CHAT_ADMIN_REMOVED = 11;
   */
  CHAT_ADMIN_REMOVED = 11,

  /**
   * @generated from enum value: CHAT_ADMINS_REMOVED = 12;
   */
  CHAT_ADMINS_REMOVED = 12,

  /**
   * @generated from enum value: CHAT_USER_REMOVED = 13;
   */
  CHAT_USER_REMOVED = 13,

  /**
   * @generated from enum value: CHAT_USERS_REMOVED = 14;
   */
  CHAT_USERS_REMOVED = 14,

  /**
   * @generated from enum value: CHAT_USER_ADDED = 15;
   */
  CHAT_USER_ADDED = 15,

  /**
   * @generated from enum value: CHAT_USERS_ADDED = 16;
   */
  CHAT_USERS_ADDED = 16,

  /**
   * @generated from enum value: MESSAGE_NEW = 17;
   */
  MESSAGE_NEW = 17,

  /**
   * @generated from enum value: MESSAGE_USER_MENTIONED = 18;
   */
  MESSAGE_USER_MENTIONED = 18,

  /**
   * @generated from enum value: USER_REPLIED_ON_MESSAGE = 19;
   */
  USER_REPLIED_ON_MESSAGE = 19,

  /**
   * @generated from enum value: NEW_THREAD_MESSAGE = 20;
   */
  NEW_THREAD_MESSAGE = 20,

  /**
   * @generated from enum value: NEW_COMMENT_ON_MESSAGE = 21;
   */
  NEW_COMMENT_ON_MESSAGE = 21,

  /**
   * @generated from enum value: USER_REACTED_ON_MESSAGE = 22;
   */
  USER_REACTED_ON_MESSAGE = 22,

  /**
   * @generated from enum value: MESSAGE_FORWARD = 23;
   */
  MESSAGE_FORWARD = 23,

  /**
   * @generated from enum value: MESSAGE_PIN = 24;
   */
  MESSAGE_PIN = 24,

  /**
   * @generated from enum value: MESSAGE_CONFIRM = 25;
   */
  MESSAGE_CONFIRM = 25,

  /**
   * @generated from enum value: MESSAGE_DELETE = 26;
   */
  MESSAGE_DELETE = 26,

  /**
   * @generated from enum value: CALL = 27;
   */
  CALL = 27,
}

/**
 * Describes the enum com.gem.bff.contract.PushNotificationRealtimeEvent.Type.
 */
export const PushNotificationRealtimeEvent_TypeSchema: GenEnum<PushNotificationRealtimeEvent_Type> =
  /*@__PURE__*/
  enumDesc(file_realtime_event_realtime_event, 15, 0);

/**
 * @generated from message com.gem.bff.contract.CallUpdate
 */
export type CallUpdate = Message<'com.gem.bff.contract.CallUpdate'> & {
  /**
   * @generated from field: int64 chatId = 1;
   */
  chatId: bigint;

  /**
   * @generated from field: string channelId = 2;
   */
  channelId: string;

  /**
   * @generated from field: com.gem.bff.contract.CallUpdate.CallStatus status = 3;
   */
  status: CallUpdate_CallStatus;
};

/**
 * Describes the message com.gem.bff.contract.CallUpdate.
 * Use `create(CallUpdateSchema)` to create a new message.
 */
export const CallUpdateSchema: GenMessage<CallUpdate> =
  /*@__PURE__*/
  messageDesc(file_realtime_event_realtime_event, 16);

/**
 * @generated from enum com.gem.bff.contract.CallUpdate.CallStatus
 */
export enum CallUpdate_CallStatus {
  /**
   * @generated from enum value: IN_PROGRESS = 0;
   */
  IN_PROGRESS = 0,

  /**
   * @generated from enum value: DECLINED = 1;
   */
  DECLINED = 1,

  /**
   * @generated from enum value: UNANSWERED = 2;
   */
  UNANSWERED = 2,

  /**
   * @generated from enum value: FINISHED = 3;
   */
  FINISHED = 3,
}

/**
 * Describes the enum com.gem.bff.contract.CallUpdate.CallStatus.
 */
export const CallUpdate_CallStatusSchema: GenEnum<CallUpdate_CallStatus> =
  /*@__PURE__*/
  enumDesc(file_realtime_event_realtime_event, 16, 0);

/**
 * @generated from message com.gem.bff.contract.CalendarUpdateRealtimeEvent
 */
export type CalendarUpdateRealtimeEvent =
  Message<'com.gem.bff.contract.CalendarUpdateRealtimeEvent'> & {
    /**
     * @generated from field: com.gem.bff.contract.CalendarEvent event = 1;
     */
    event?: CalendarEvent;

    /**
     * @generated from field: com.gem.bff.contract.CalendarAction action = 2;
     */
    action: CalendarAction;
  };

/**
 * Describes the message com.gem.bff.contract.CalendarUpdateRealtimeEvent.
 * Use `create(CalendarUpdateRealtimeEventSchema)` to create a new message.
 */
export const CalendarUpdateRealtimeEventSchema: GenMessage<CalendarUpdateRealtimeEvent> =
  /*@__PURE__*/
  messageDesc(file_realtime_event_realtime_event, 17);
